import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const BXScoreReadmoreContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${(p) => p.theme.spacing(2)};
  &:hover {
    cursor: pointer;
  }
`;

export const BXScoreReadmore = styled(Typography)`
  color: ${(p) => p.theme.palette.text.primary};
`;

export const BXScoreContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radius[30]};
  background: ${({ theme }) => theme.palette.interface.default};
  padding: ${({ theme }) => theme.space(30)};
  height: 150px;
`;

export const HeaderContainer = styled(Box)`
  width: 100%;
`;

export const ScoreContainer = styled(Box)`
  width: 100%;
  height: 152px;
`;
